import React from 'react';

export class UI {
  public static modalMaskStyle(): React.CSSProperties {
    return { backdropFilter: 'blur(11px)', WebkitBackdropFilter: 'blur(11px)', background: '#7474802E' };
  }
}
